import styled from "styled-components";

export const AppContent = styled.div`
  width: 100%;
  overflow-x: hidden;
  padding-top: 12px;
  padding-bottom: 16px;
`;
